var Layred = (function () {
  var handleTextChar = function () {
    var wordRoateElements = document.querySelectorAll('.word-rotate');
    wordRoateElements.forEach((data, _) => {
      var wordRoate = $(data).text().split('');
      const step = 360 / wordRoate.length;
      wordRoate.forEach((el, i) => {
        $(data)
          .closest('.word-rotate-box')
          .append('<span class="text__char" style="--char-rotate :' + i * step + 'deg">' + el + '</span>');
      });
      $(data).remove();
    });
  };

  var handleLightGallery = function () {
    if (jQuery('#lightgallery').length > 0) {
      lightGallery(document.getElementById('lightgallery'), {
        plugins: [lgThumbnail, lgZoom, lgVideo],
        selector: '.lg-item',
        thumbnail: true,
        exThumbImage: 'data-src',
      });
    }
  };

  var handleShowPassword = function () {
    $('.dz-search-password .show-pass').on('click', function () {
      $(this).parent().toggleClass('show');
      if ($(this).parent().hasClass('show')) {
        $(this).parent().find('input').attr('type', 'text');
      } else {
        $(this).parent().find('input').attr('type', 'password');
      }
    });
  };

  var handleResizeElement = function () {
		var headerTop = 0;
		var headerNav = 0;

		$('.header .sticky-header').removeClass('is-fixed');
		$('.header').removeAttr('style');

		if (jQuery('.header .top-bar').length > 0 && screenWidth > 991) {
			headerTop = parseInt($('.header .top-bar').outerHeight());
		}

		if (jQuery('.header').length > 0) {
			headerNav = parseInt($('.header').height());
			headerNav = (headerNav == 0) ? parseInt($('.header .main-bar').outerHeight()) : headerNav;
		}

		var headerHeight = headerNav + headerTop;

		jQuery('.header').css('height', headerHeight);
	}

  var headerFix = function () {
		/* Main navigation fixed on top  when scroll down function custom */
		jQuery(window).on('scroll', function () {
			if (jQuery('.sticky-header').length > 0) {
				var menu = jQuery('.sticky-header');
				if ($(window).scrollTop() > menu.offset().top) {
					menu.addClass('is-fixed');
				} else {
					menu.removeClass('is-fixed');
				}
			}
		});
		/* Main navigation fixed on top  when scroll down function custom end*/
	}


  /* Function ============ */
  return {
    init: function () {
      handleTextChar();
      handleLightGallery();
      handleShowPassword();
      headerFix();
    },

    load: function () {
      handleResizeElement();
    },

    scroll: function () {},

    resize: function () {
      handleResizeElement();
    },
  };
})();

/* Document.ready Start */
jQuery(document).ready(function () {
  'use strict';
  Layred.init();
});
/* Document.ready END */

/* Window Load START */
jQuery(window).on('load', function () {
  'use strict';
  Layred.load();
});
/*  Window Load END */

/* Window Resize START */
jQuery(window).on('resize', function () {
  'use strict';
  Layred.resize();
});
/*  Window Resize END */

/* Window scroll START */
jQuery(window).on('scroll', function () {
  'use strict';
  Layred.scroll();
});
/*  Window scroll END */



/* Motion: slide-in reveal for price cards + count-up for stat numbers.
   Skipped entirely for visitors who prefer reduced motion. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  function initMotion() {
    /* 1. Slide-in reveal for price cards */
    var revealConfigs = [
      { sel: '.tm-price-row, .tm-spec-grid, .bt-grid, .wb-svc-row', dir: 'left', step: 110, cols: 3 },
      { sel: '.ts-written-grid, .bf-testi-grid, .tm-testi-grid', dir: 'up', step: 120, cols: 3 },
      { sel: '.bf-steps-row, .wb-steps-list', dir: 'up', step: 170, cols: 3 },
      { sel: '.bf-services-row, .bf-benefits-row', dir: 'up', step: 130, cols: 3 },
      { sel: '.bf-systems-grid, .tm-t-grid', dir: 'up', step: 80, cols: 4 },
      { sel: '.ct-info-grid, .ts-video-row', dir: 'up', step: 130, cols: 3 },
      { sel: '.tm-pills', dir: 'up', step: 35, cols: 8 },
      { sel: '.au-crystal .au-wrap, .tm-nfr .tm-wrap, .tm-hero .tm-wrap, .bf-hero .bf-wrap, .bf-tech .bf-wrap, .wb-session .wb-wrap, .image-content-inner', dir: 'split', step: 140, cols: 2 }
    ];
    var groups = [];
    revealConfigs.forEach(function (cfg) {
      document.querySelectorAll(cfg.sel).forEach(function (g) {
        g._reveal = cfg;
        groups.push(g);
      });
    });
    var blogCards = document.querySelectorAll('.blog-card');
    var revealIO = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          el.classList.add('is-in');
          revealIO.unobserve(el);
          setTimeout(function () { el.style.transitionDelay = ''; }, 1400);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    groups.forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        child.classList.add('ahs-reveal');
        var cfg = group._reveal;
        if (cfg.dir === 'left') child.classList.add('ahs-reveal--left');
        if (cfg.dir === 'split') child.classList.add(i === 0 ? 'ahs-reveal--left' : 'ahs-reveal--right');
        child.style.transitionDelay = (i % cfg.cols) * cfg.step + 'ms';
        revealIO.observe(child);
      });
    });

    /* Section headings and centred intro text fade up */
    document
      .querySelectorAll('.bf-head, .tm-head, .ts-head, .wb-head, .au-mission .au-inner, .tm-different .tm-inner, .tm-adapts .tm-inner')
      .forEach(function (el) {
        el.classList.add('ahs-reveal');
        revealIO.observe(el);
      });

    /* Blog feed cards rise into view */
    blogCards.forEach(function (card) {
      card.classList.add('ahs-reveal');
      revealIO.observe(card);
    });

    /* 2. Count-up for stat numbers */
    var nums = document.querySelectorAll('.au-num');
    var countIO = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          countIO.unobserve(el);
          var d = el._count;
          var start = null;
          var duration = 1800;
          function step(ts) {
            if (start === null) start = ts;
            var p = Math.min((ts - start) / duration, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            var val = Math.round(d.target * eased);
            el.textContent = d.prefix + (d.comma ? val.toLocaleString('en-US') : val) + d.suffix;
            if (p < 1) requestAnimationFrame(step);
            else el.textContent = d.original;
          }
          requestAnimationFrame(step);
        });
      },
      { threshold: 0.4 }
    );
    nums.forEach(function (el) {
      var original = el.textContent.trim();
      var m = original.match(/^([^0-9]*)([\d,\.]+)(.*)$/);
      if (!m) return;
      el._count = {
        original: original,
        prefix: m[1],
        suffix: m[3],
        comma: m[2].indexOf(',') > -1,
        target: parseFloat(m[2].replace(/,/g, ''))
      };
      el.textContent = m[1] + '0' + m[3];
      countIO.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMotion);
  } else {
    initMotion();
  }
})();



